// @flow
import React from 'react';
import { withRouter, Link } from 'react-router-dom';

import './AccountPage.scss';

type Props = {
  account: Object,
  actions: Object,
  location: {
    pathname: string,
  },
  children: Object,
  accountDetailsPath: string,
  accountAddressesPath: string,
};

class AccountPageComponent extends React.Component<Props> {
  constructor(props: Props): void {
    super(props);
    this.tabs = [
      {
        id: 'details',
        path: props.accountDetailsPath,
        name: 'Your details',
      },
      {
        id: 'addresses',
        path: props.accountAddressesPath,
        name: 'Addresses',
      },
    ];
    const path = props.location.pathname;

    const foundTab = this.tabs.find((item) => item.path === path);
    this.tabSelected = foundTab ? foundTab.id : '';
  }

  render(): Element {
    return (
      <div className="account-page-component">
        <div className="title">
          <h3>Your Account</h3>
        </div>
        <div className="tabs">
          {this.tabs.map((tab) => (
            <Link to={tab.path} key={tab.id} className={tab.id === this.tabSelected ? 'selected' : ''}>
              <span className="tab">
                <h5>{tab.name}</h5>
              </span>
            </Link>
          ))}
        </div>
        <div className="page-body">{this.props.children(this.props)}</div>
      </div>
    );
  }
}

export default withRouter(AccountPageComponent);
